import { gql } from '@apollo/client';

export const fetchMyProfile = gql`
  query getMyProfile($kaercherUserId: ID!) {
    getMyProfile(kaercherUserId: $kaercherUserId) {
      displayName
      organization
      phoneNumber
      preferredLanguage
    }
  }
`;
